import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';
import { IdGeneratorPipe, TooltipDirective, TooltipPosition } from 'ngx-lib';

@Component({
    selector: 'app-dashboard-card',
    templateUrl: './dashboard-card.component.html',
    styleUrls: ['./dashboard-card.component.scss'],
    imports: [CommonModule, IdGeneratorPipe, TooltipDirective]
})
export class DashboardCardComponent {
    contentType = input<'stat' | 'chart'>('stat');

    icon = input<SafeHtml>();

    tooltip = input<string>();

    tooltipPosition = input<TooltipPosition>(TooltipPosition.ABOVELEFT);

    dashboardCardId = input<string>();
}
